import { GeneralModal } from '@framework/ui/elements/GeneralModal';
import { Button } from '@framework/ui/atoms/Button';
import type { UserEntity } from '@user/UserEntity';
import { useCallback } from 'react';
import type { Workspace } from '@workspace/domain/workspace';
import { WorkspaceOperation } from '@workspace/domain/WorkspaceOperation';
import { toast } from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

type Props = {
  isOpen: boolean;
  memberData: Pick<UserEntity, 'id' | 'name'>;
  workspace: Workspace;
  onClose(): void;
};

export const WorkspaceMemberDeleteConfirmModal: React.FC<Props> = ({
  isOpen,
  memberData,
  workspace,
  onClose,
}: Props) => {
  const { t } = useTranslation();
  const handleSubmit = useCallback(async () => {
    try {
      await WorkspaceOperation.removeMembers(workspace.id, workspace.groupId, [memberData.id]);
      toast.success(t('group.workspaceMemberDelete.toast.success'));
      onClose();
    } catch (e) {
      console.error(e);
      toast.error(t('group.workspaceMemberDelete.toast.error'));
    }
  }, [memberData, workspace, onClose, t]);

  return (
    <GeneralModal
      isOpen={isOpen}
      submitButton={
        <Button color="danger" onClick={handleSubmit}>
          {t('common.action.delete')}
        </Button>
      }
      cancelButton={
        <Button color="secondary" onClick={onClose}>
          {t('common.action.cancel')}
        </Button>
      }
      onClose={onClose}
      shouldCloseOnOverlayClick={false}
      title={t('group.workspaceItem.deleteButton')}
    >
      <div className="p-4" style={{ width: '600px' }}>
        <p className={'pb-4'}>
          {t('group.workspaceMemberDelete.modal.warning')}
          <br />
          {t('group.workspaceMemberDelete.modal.confirm', {
            name: memberData.name,
            workspaceName: workspace.name.value,
          })}
        </p>
      </div>
    </GeneralModal>
  );
};
